import CounselorClient from '@/api/CounselorClient'
import moment from 'moment';

export default class PatientDetailModel {
  constructor(http) {
    this.initializing = true;
    this.client = new CounselorClient(http);
  }

  async initialize(counselorId, studentUserId) {
    this.counselorId = counselorId;
    this.studentUserId = studentUserId;

    try {
      const patient = await this.client
        .getPatientDetail(this.counselorId, this.studentUserId);

      this.individualCreditsRemaining = patient.individualCreditsRemaining;
      this.groupCreditsRemaining = patient.groupCreditsRemaining;

      this.classYear = patient.classYear;
      this.isFullTimeStudent = patient.isFullTimeStudent;
      this.isInternationalStudent = patient.isInternationalStudent;
      this.isStudentAthlete = patient.isStudentAthlete;
      this.studentIdNumber = patient.studentIdNumber;

      this.bio = patient.bio;
      this.city = patient.city;
      this.email = patient.email;
      this.dateOfBirth = patient.dateOfBirth ? moment(patient.dateOfBirth) : null;
      this.ethnicity = patient.ethnicity;
      this.fullName = patient.fullName;
      this.gender = patient.gender;
      this.phoneNumber = patient.phoneNumber;
      this.state = patient.state;

      this.photoUrl = patient.photoUrl;
      this.authReleaseFormUrl = patient.authReleaseFormUrl;

      this.outcomes = patient.outcomes || [];
      this.struggles = patient.struggles || [];

      this.school = patient.school;

      // We should always have crisis triage. If we don't they should reach out to us.
      if (!this.school.triage.crisis) {
        this.school.triage.crisis = 'Contact BetterMynd for details.'
      }
    } finally {
      this.initializing = false;
    }
  }
}
